<template>
  <div>
    <div class="container container-fluid" >
      <div id="carouselControls" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner text-center rounded" >
          <div v-for='(photo, index) in photos' :key='photo.dateAdded' :class='{active: isActive(index)}' class='carousel-item' >
            <img class="img-fluid" v-bind:src='photo.url' >
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselControls" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselControls" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">next</span>
        </a>
      </div>
    </div>
    <h4>Welcome to my website.</h4>
    <i>wow. this site is really broken right now<br> awkward... </i>
    Things I am using to run this site:
    <ul>
      <li>
        Vue.JS <br>
        I have written the front end using Vue.JS and building it as a static website.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      photos: []
    }
  },
  mounted () {
    this.$http.get('/photos?query={"carousel":true}').then((res) => {
      this.photos = res.data
    })
  },
  methods: {
    isActive (x) {
      return x === 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue